import React from "react";
import { Link } from "react-router-dom";

const PageContext = ({ items = [], note = "" }) => {
  if (!items.length && !note) return null;

  return (
    <section className="page-context">
      {items.length > 0 ? (
        <div className="page-context-path" aria-label="Page context">
          {items.map((item, index) => (
            <React.Fragment key={`${item.label}-${index}`}>
              {index > 0 ? <span className="page-context-separator">/</span> : null}
              {item.to ? (
                <Link className="page-context-link" to={item.to}>{item.label}</Link>
              ) : (
                <span className="page-context-current">{item.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>
      ) : null}
      {note ? <div className="page-context-note">{note}</div> : null}
    </section>
  );
};

export default PageContext;
